export default __webpack_public_path__ + "static/media/choicelogo.2d0a81d6.png";